var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getParticipantsByShiftIdFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const getParticipantsByShiftIdFetchKey = 'getParticipantsByShiftId';
export function useParticipantsByShiftId(requestParams) {
    const getParticipantsByShiftIdPlatformFn = useTypedPlatformFunction(getParticipantsByShiftIdFunctionDef);
    const fetch = () => __awaiter(this, void 0, void 0, function* () {
        // TODO: Remove Type Casting after PLAT-2704
        const res = yield getParticipantsByShiftIdPlatformFn(requestParams);
        return res;
    });
    const { data: participants, mutate, isLoading, } = useSWR([getParticipantsByShiftIdFetchKey, ...Object.values(requestParams)], () => {
        if (!requestParams.shiftId) {
            return undefined;
        }
        return fetch();
    }, Object.assign(Object.assign({}, defaultFetcherOptions), { onError: (error) => handleErrorSnackbar(error) }));
    const fetchParticipants = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        participants,
        isLoading,
        fetchParticipants,
    };
}
